import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { scrollToTarget } from "../components/SmoothScroll";

// Sections on the home page that the nav and footer link to.
// Some anchors scroll to an inner element and need a different offset.
const INNER_TARGETS = { "#reviews": "#reviews-rows" };

export const resolveAnchor = (anchor) => {
  const target = INNER_TARGETS[anchor] || anchor;
  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;
  let offset = -90;
  if (anchor === "#reviews") offset = isMobile ? -100 : -200;
  return { target, offset };
};

// Scroll to a home-page section without ever leaving a "#hash" in the URL.
export const scrollToAnchor = (anchor) => {
  if (anchor === "#top") {
    scrollToTarget(0);
    return;
  }
  const { target, offset } = resolveAnchor(anchor);
  scrollToTarget(target, { offset });
};

// Hook for links that point at a home-page section. On the home page it
// smooth-scrolls; on any other page it navigates home and the Navbar
// scrolls once the section has mounted, then clears the hash.
export const useAnchorNav = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  return useCallback(
    (anchor) => (e) => {
      if (e) e.preventDefault();
      if (pathname === "/") scrollToAnchor(anchor);
      else navigate(anchor === "#top" ? "/" : `/${anchor}`);
    },
    [pathname, navigate]
  );
};
